const Error404 = () => {
  return (
    <h1>Page Not Found</h1>
  );
};

export default Error404;
